import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {DesignServicesModel} from '../../../../models/DesignServicesModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-tower-filter',
  templateUrl: './tower-filter.component.html',
  styleUrls: ['./tower-filter.component.scss']
})
export class TowerFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listFilterDesignService: any[];
  optionSelected: any;

  @Input() designServicesData: any;
  @Input() designServicesSelected: DesignServicesModel;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('designServicesData' in changes) {
      this.listFilterDesignService = this.designServicesData ? this.designServicesData : [];
      this.optionSelected = null;
    }
    if (this.designServicesSelected) {
      this.optionSelected = this.designServicesSelected;
    }
  }

  ngOnDestroy(): void {
  }
}
